/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ linked: NonNullable<unknown>, moved: NonNullable<unknown>, unchanged: NonNullable<unknown>, skipped: NonNullable<unknown> }} Pm_ResultInputs */

const cs_pm_result = /** @type {(inputs: Pm_ResultInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Uloženo: ${i?.linked} nových, ${i?.moved} přesunutých, ${i?.unchanged} beze změny, ${i?.skipped} přeskočeno.`)
};

const en_pm_result = /** @type {(inputs: Pm_ResultInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Saved: ${i?.linked} new, ${i?.moved} moved, ${i?.unchanged} unchanged, ${i?.skipped} skipped.`)
};

/**
* | output |
* | --- |
* | "Saved: {linked} new, {moved} moved, {unchanged} unchanged, {skipped} skipped." |
*
* @param {Pm_ResultInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_result = /** @type {((inputs: Pm_ResultInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_ResultInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_result(inputs)
	return cs_pm_result(inputs)
});